const getIntercomEnrollmentQuery = version => {
    return `query IntercomQuery {
        getIntercomEnrollment_${version} {
          instId
          instName
          intercomAppId
          products
          rootInstitutions {
            instType
            name
            uid
          }
          userEmail
          userId
        }
      }`;
};

export default getIntercomEnrollmentQuery;
